import { render, staticRenderFns } from "./checkout-select-payment.vue?vue&type=template&id=f5a95130&scoped=true&"
import script from "./checkout-select-payment.vue?vue&type=script&lang=js&"
export * from "./checkout-select-payment.vue?vue&type=script&lang=js&"
import style0 from "./checkout-select-payment.vue?vue&type=style&index=0&id=f5a95130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a95130",
  null
  
)

export default component.exports